import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  FolderKanban,
  ListTodo,
  KanbanSquare,
  Clock,
  FileBarChart,
  Settings,
  Users
} from 'lucide-react';
import { cn } from '../../lib/utils';
import { useAuth } from '../../context/AuthContext';

const navItems = [
  { to: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/projects', icon: FolderKanban, label: 'Projets' },
  { to: '/work-items', icon: ListTodo, label: 'Tâches' },
  { to: '/sprint', icon: KanbanSquare, label: 'Sprint' },
  { to: '/time-entries', icon: Clock, label: 'Temps' },
  { to: '/reports', icon: FileBarChart, label: 'Rapports', adminOnly: true },
  { to: '/users', icon: Users, label: 'Utilisateurs', adminOnly: true },
  { to: '/settings', icon: Settings, label: 'Paramètres' },
];

export const MobileBottomNav = () => {
  const { user } = useAuth();
  const isAdmin = user?.role === 'admin';

  return (
    <nav className="mobile-bottom-nav">
      {navItems
        .filter((item) => !item.adminOnly || isAdmin)
        .map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) => cn(
            "mobile-nav-item",
            isActive && "mobile-nav-item-active"
          )}
          data-testid={`mobile-nav-${item.label.toLowerCase().replace(' ', '-')}`}
        >
          <item.icon className="h-5 w-5" />
        </NavLink>
      ))}
    </nav>
  );
};
